import React from 'react';

export default ({ url, className, ...props }) => (
  <img className={`image ${className || ''}`} alt={'img'} src={url} />
);
